// @ts-nocheck
// import constants from "@store/constants"; // Store Custom Code
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
// import ProductPrimaryImage from "@store/Overrides/Components/ProductPrimaryImage"; // Store Custom Code
// import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing"; // Store Custom Code
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { ImageModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useState } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import constants from "@store/constants";
import ProductPrimaryImage from "@store/Overrides/Components/ProductPrimaryImage";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
/* Store Custom Code - End */

type Props = WidgetProps & HasProduct;

export interface SizeChartStyles {
    linkWrapper: InjectableCss;
    productDetails?: InjectableCss;
    sizeChartImageModal?: ModalPresentationProps;
}

const _zoomViewSize = 95;

export const primaryImageStyles: SizeChartStyles = {
    productDetails: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            ${contentSpacingStyles(0, 0, pxToRem(25))}
            padding-bottom: ${pxToRem(25)};
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

            > * {
                ${contentSpacingStyles(0, 0, pxToRem(15))}
            }
        `,
    },
    linkWrapper: {
        css: css`
            width: 130px;
        `,
    },
    sizeChartImageModal: {
        cssOverrides: {
            modalContainer: css`
                width: auto;
            `,
            modalBody: css`
                width: auto;
                height: auto !important;
                max-width: ${_zoomViewSize}vw !important;
                max-height: ${_zoomViewSize}vh !important;
                padding: 32px;
            `,
            modalTitle: css`
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                padding: 0;
                border: 0;
            `,
            modalContent: css`
                padding: 0;
                text-align: center;
            `,
        },
        closeButtonProps: {
            shape: "rectangle",
            color: undefined,
            size: undefined,
            buttonType: undefined,
            css: css`
                border: 0;
                background-color: ${getColor("common.background")};
                padding: 0.5em;
                height: auto;
                transition: none;

                &:focus {
                    outline-offset: -${({ theme }) => theme?.focus?.width};
                }
            `,
        },
    },
};

const styles = primaryImageStyles;

const ProductSizingChart: FC<Props> = ({ product }) => {
    const [sizeChartModalIsOpen, setSizeChartModalIsOpen] = useState<boolean>(false);
    const parentProductState = useParentProductState();

    if (!product) {
        return null;
    }

    const productSizeChart = product.images?.filter(i => i.name.includes(constants.imageTypes.sizeChart)).shift();
    const parentSizeChart = parentProductState?.images
        ?.filter(i => i.name.includes(constants.imageTypes.sizeChart))
        .shift();

    if (!productSizeChart && !parentSizeChart) {
        return null;
    }

    const sizeChart = productSizeChart || parentSizeChart;

    const image = {
        id: product.id,
        imageAltText: sizeChart?.imageAltText,
        imageType: "Static",
        largeImagePath: sizeChart?.largeImagePath,
        mediumImagePath: sizeChart?.mediumImagePath,
        smallImagePath: sizeChart?.smallImagePath,
    } as ImageModel;

    return (
        <StyledWrapper {...styles.productDetails}>
            <StyledWrapper {...styles.linkWrapper}>
                <Link
                    onClick={() => {
                        setSizeChartModalIsOpen(true);
                    }}
                >
                    {translate("View Size Chart")}
                </Link>
            </StyledWrapper>

            <Modal
                {...styles.sizeChartImageModal}
                isOpen={sizeChartModalIsOpen}
                handleClose={() => setSizeChartModalIsOpen(false)}
            >
                <ProductPrimaryImage product={product} image={image} showLoader={true} />
            </Modal>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductSizingChart),
    definition: {
        displayName: "Sizing Chart",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
